import jQuery from 'jquery'
import 'jcarousel'

const spotlightWidth = () => jQuery('.image-carousel .spotlight').outerWidth()

const spotlightTop = () => jQuery('.image-carousel .spotlight').offset().top

const overlayContentBottom = function() {
  const content = jQuery('.image-carousel .overlay-content')
  return content.offset().top + content.outerHeight()
}

const handleOverlayContent = function() {
  if ((jQuery('.image-carousel .overlay-left').width() < 1) ||
      (jQuery('.image-carousel .spotlight').offset().top >= overlayContentBottom())) {
    jQuery('.image-carousel .overlay-content').removeClass('on-overlay')
  } else {
    jQuery('.image-carousel .overlay-content').addClass('on-overlay')
  }
}

const adjustOverlay = function() {
  const spotlightSelector = jQuery('.image-carousel .spotlight')
  const overlayRightSelector = jQuery('.image-carousel .overlay-right')
  const overlayLeftSelector = jQuery('.image-carousel .overlay-left')

  const leftOffsetOfRightOverlay = spotlightSelector.offset().left + spotlightWidth()
  const widthOfRightOverlay = jQuery(window).width() - leftOffsetOfRightOverlay

  if (widthOfRightOverlay <= 0) {
    overlayRightSelector.width(0)
  } else {
    overlayRightSelector.offset({ left: leftOffsetOfRightOverlay })
    overlayRightSelector.width(widthOfRightOverlay)
  }

  const widthOfLeftOverlay = spotlightSelector.offset().left

  if (widthOfLeftOverlay <= 0) {
    overlayLeftSelector.width(0)
  } else {
    overlayLeftSelector.offset({ top: spotlightTop() })
    overlayLeftSelector.width(widthOfLeftOverlay)
  }

  handleOverlayContent()
  adjustOverlayContentHeight()

  if (widthOfRightOverlay > 0) {
    overlayRightSelector.offset({ top: spotlightTop() })
  }
  if (widthOfLeftOverlay > 0) {
    overlayLeftSelector.offset({ top: spotlightTop() })
  }
}

const adjustCarouselItemsWidth = () => jQuery('.image-carousel .carousel-items li').css('width', spotlightWidth())

const adjustOverlayContentHeight = function() {
  jQuery('.image-carousel .overlay-content').css('height', 'auto')
  jQuery('.image-carousel .overlay-content.on-overlay').css('height', jQuery('.image-carousel .spotlight').height())
}

jQuery(() => {
  adjustCarouselItemsWidth()
  const carouselSelector = jQuery('.image-carousel .jcarousel')
  const carouselControlSelector = jQuery('.image-carousel .jcarousel-control')

  // Show the description box only on the spotlighted item
  // HACK: jQuery show() / hide() does not work in scenarios for some reason so we just set
  // display CSS property directly to block / none
  carouselSelector.on('jcarousel:targetin', 'li', (event) => {
    jQuery(event.target).find('.list-item-desc-box').css('display', 'block')
  })
  carouselSelector.on('jcarousel:targetout', 'li', (event) => {
    jQuery(event.target).find('.list-item-desc-box').css('display', 'none')
  })

  // Set up the carousel
  carouselSelector.jcarousel({wrap: 'both'})

  // Start with the 2nd item in the spotlight
  carouselSelector.jcarousel('scroll', 1, false)

  // Set up the prev/next buttons
  carouselControlSelector.on('jcarouselcontrol:inactive', (event) => jQuery(event.target).css('display', 'none'))
  carouselControlSelector.on('jcarouselcontrol:active', (event) => jQuery(event.target).css('display', 'block'))

  jQuery('.image-carousel .jcarousel-control-prev').jcarouselControl({target: '-=1'})
  jQuery('.image-carousel .jcarousel-control-next').jcarouselControl({target: '+=1'})

  // Line up the overlay and its content
  adjustOverlay()

  // On resize, get everything aligned right with the new window size.
  const realignOnResize = function() {
    adjustCarouselItemsWidth()
    carouselSelector.jcarousel('reload')
    adjustOverlay()
  }

  jQuery(window).on('resize', realignOnResize)
  jQuery(window).on('unload', () => {
    window.removeEventListener('resize', realignOnResize)
  })
})
